import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { QrCodeIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
export const Setup2FAPage = () => {
  const [qrCode, setQrCode] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [error, setError] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const {
    setup2FA,
    verify2FA
  } = useAuth();
  useEffect(() => {
    const initSetup = async () => {
      try {
        const secret = await setup2FA();
        // In production, this would be a proper QR code URL
        setQrCode(`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${secret}`);
      } catch (err) {
        setError('Failed to initialize 2FA setup');
      }
    };
    initSetup();
  }, []);
  const handleVerify = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsVerifying(true);
    setError('');
    try {
      const isValid = await verify2FA(verificationCode);
      if (isValid) {
        setIsSuccess(true);
      } else {
        setError('Invalid verification code');
      }
    } catch (err) {
      setError('Failed to verify code');
    } finally {
      setIsVerifying(false);
    }
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-3487">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-3488">
        <div className="flex justify-center" data-id="element-3489">
          <QrCodeIcon className="h-12 w-12 text-blue-600" data-id="element-3490" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-3491">
          Set up Two-Factor Authentication
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-3492">
          Enhance your account security with 2FA
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-3493">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-3494">
          <div className="space-y-6" data-id="element-3495">
            {!isSuccess ? <>
                <div data-id="element-3496">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-3497">
                    Step 1: Scan QR Code
                  </h3>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-3498">
                    Scan this QR code with your authenticator app
                  </p>
                  <div className="mt-4 flex justify-center" data-id="element-3499">
                    {qrCode && <img src={qrCode} alt="2FA QR Code" className="h-48 w-48 border border-gray-200 rounded-lg" data-id="element-3500" />}
                  </div>
                </div>
                <form onSubmit={handleVerify} data-id="element-3501">
                  <div data-id="element-3502">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-3503">
                      Step 2: Verify Code
                    </h3>
                    <p className="mt-1 text-sm text-gray-500" data-id="element-3504">
                      Enter the 6-digit code from your authenticator app
                    </p>
                    <div className="mt-4" data-id="element-3505">
                      <input type="text" maxLength={6} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" value={verificationCode} onChange={e => setVerificationCode(e.target.value)} placeholder="Enter 6-digit code" data-id="element-3506" />
                    </div>
                  </div>
                  {error && <div className="rounded-md bg-red-50 p-4" data-id="element-3507">
                      <div className="flex" data-id="element-3508">
                        <XCircleIcon className="h-5 w-5 text-red-400" data-id="element-3509" />
                        <div className="ml-3" data-id="element-3510">
                          <p className="text-sm font-medium text-red-800" data-id="element-3511">
                            {error}
                          </p>
                        </div>
                      </div>
                    </div>}
                  <button type="submit" disabled={isVerifying || verificationCode.length !== 6} className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${isVerifying || verificationCode.length !== 6 ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-3512">
                    {isVerifying ? 'Verifying...' : 'Verify and Enable 2FA'}
                  </button>
                </form>
              </> : <div className="text-center" data-id="element-3513">
                <CheckCircleIcon className="mx-auto h-12 w-12 text-green-400" data-id="element-3514" />
                <h3 className="mt-2 text-xl font-medium text-gray-900" data-id="element-3515">
                  2FA Successfully Enabled
                </h3>
                <p className="mt-2 text-sm text-gray-500" data-id="element-3516">
                  Your account is now protected with two-factor authentication.
                </p>
                <div className="mt-6" data-id="element-3517">
                  <button type="button" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onClick={() => window.location.href = '/'} data-id="element-3518">
                    Return to Dashboard
                  </button>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </div>;
};